// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { push } from 'react-router-redux'
import { SubmissionError } from 'redux-form'
import prepAndAssignUserData from './prepAndAssignUserData'
import { loadingToggler } from 'redux/modules/loading'
import { postUserLogin } from 'helpers/api'

// d here is the login form's data
const logUserIn = (formValues, referrer) => dispatch => (
  dispatch(loadingToggler(
    async () => {
      const { userName } = formValues
      // converts pw to base64 in place of sending plain text over request
      const password = btoa(formValues.userPassword)

      const userInfo = {
        userName,
        password,
      }

      try {
        const { entity } = await postUserLogin(userInfo)
        await dispatch(prepAndAssignUserData(entity))
        dispatch(push(referrer || '/'))
      } catch (err) {
        console.warn(err)
        throw new SubmissionError({ _error: err.message })
      }
    }
  ))
)

export default logUserIn
